import { Service } from '@angular/core';
import type { Observable } from 'rxjs';
import type { OnyxOption } from '../directives/interfaces';

@Service()
export abstract class OnyxDictionariesService {
  public abstract getDictionary(code: string): Observable<OnyxOption<string>[]>;
}
